import venuesSliderTable from './modules/venuesSliderTable';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    venuesSliderTable();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptOccasion.js